const dataLayerLogic = {
    ytPlayers: {},
    ytApiReady: false,
    is_initialized: false, // Add a flag to track initialization

    init() {
        if (this.isPageContainsSmallContentSwiperSlider()) {
            // edge case for small content slider as swiper is making duplicates in the loop mode, those are created later in the DOM
            const swipers = document.querySelectorAll('.small-content-slider .swiper');

            swipers.forEach((swiper) => {
                this.observeNewSlides(swiper);
            });
        } else {
            this.addHTMLVideoListeners();
        }
    },

    addHTMLVideoListeners() {
        const videos = document.querySelectorAll('video');

        if (!videos.length) return;

        videos.forEach((video) => {
            if (video.classList.contains('data-layer-observed')) return; // Skip if the video is already observed
            let progressEventsSent = new Set();
            let isVideoPlaying = false;

            // Listen for play event
            video.addEventListener('play', () => {
                if (!isVideoPlaying) {
                    this.pushToDataLayer('video_start', video.getAttribute('name'), video.duration);
                    isVideoPlaying = true;
                }
            });

            // Listen for time updates to track progress
            video.addEventListener('timeupdate', () => {
                const currentTime = video.currentTime;
                const duration = video.duration;

                if (!duration) return;

                const progress = Math.floor((currentTime / duration) * 100);

                const roundedProgress = Math.floor(progress / 10) * 10; // Round to nearest 10
                if (roundedProgress >= 10 && !progressEventsSent.has(roundedProgress)) {
                    this.pushToDataLayer(`video_progress_${roundedProgress}%`, video.getAttribute('name'), duration);
                    progressEventsSent.add(roundedProgress);
                }

                // Send video_finish event when progress reaches 100%
                if (progress === 100) {
                    this.pushToDataLayer('video_finish', video.getAttribute('name'), duration);
                    isVideoPlaying = false;
                    progressEventsSent.clear(); // Reset for next video play
                }
            });

            // Listen for error event
            video.addEventListener('error', (e) => {
                if (video.classList.contains('video-popup__video') && video.getAttribute('src') === '#') {
                    // Ignore error event for video popup - it's designed in a way where popup is empty on load, and video src is injected later
                    return;
                }

                this.pushToDataLayer('video_error', video.getAttribute('name'), video.duration, e.message || 'unknown_error');
            });

            // Reset when video ends
            video.addEventListener('ended', () => {
                isVideoPlaying = false;
                progressEventsSent.clear();
            });

            video.classList.add('data-layer-observed'); // Add a class to mark the video as observed
        })
    },

    observeNewSlides(swiperContainer) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        // Check if the added node is a .swiper-slide
                        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('swiper-slide')) {
                            this.addHTMLVideoListeners();
                        }
                    });
                }
            });

            // Stop observing after detecting the first new slide
            observer.disconnect();
        });

        // Start observing the swiper container for child elements
        observer.observe(swiperContainer, {
            childList: true, // Observe direct children
            subtree: true // Include all descendants
        });
    },

    loadYouTubeAPI() {
        // Load the YouTube IFrame API
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Set up the API ready callback
        window.onYouTubeIframeAPIReady = () => {
            this.ytApiReady = true; // Set the flag to true when the API is ready
        };
    },

    initializeYouTubePlayer(iframe) {
        if (this.ytApiReady) {
            const player = new YT.Player(iframe, {
                events: {
                    'onStateChange': (event) => this.onPlayerStateChange(iframe, event),
                    'onError': (error) => this.onPlayerError(iframe, error) // Add onError event
                }
            });

            const index = Object.keys(this.ytPlayers).length;
            this.ytPlayers[index] = player;
        } else {
            const interval = setInterval(() => {
                if (this.ytApiReady) {
                    this.initializeYouTubePlayer(iframe);
                    clearInterval(interval);
                }
            }, 100);
        }
    },

    pushToDataLayer(event, name, duration, error_type = '') {
        const dataObject = {
            event: event.toLowerCase(),
            name: name ? name.toLowerCase() : '',
            duration: duration ? duration.toFixed(0).toLowerCase() : '',
        };

        if (error_type) {
            dataObject.error_type = error_type.toLowerCase();
        }

        console.log(dataObject);
        dataLayer.push(dataObject);
    },

    onPlayerStateChange(iframe, event) {
        const player = event.target;
        const videoData = player.getVideoData();
        const videoName = videoData.title;
        const videoDuration = player.getDuration();

        // Initialize tracking for the playback session
        if (!iframe.trackingInitialized) {
            iframe.trackingInitialized = true;
            iframe.progressEventsSent = new Set();  // Track progress events sent
            iframe.isVideoPlaying = false;          // Track if the video is playing
            iframe.startEventSent = false;          // Track if video_start event was sent
        }

        switch (event.data) {
            case YT.PlayerState.PLAYING:
                if (!iframe.startEventSent) {
                    this.pushToDataLayer('video_start', videoName, videoDuration);
                    iframe.startEventSent = true;  // Ensure video_start is sent only once
                }
                iframe.isVideoPlaying = true;
                this.startTrackingProgress(player, videoDuration, videoData, iframe);
                break;

            case YT.PlayerState.ENDED:
                this.pushToDataLayer('video_finish', videoName, videoDuration);
                iframe.isVideoPlaying = false;
                this.stopTrackingProgress(iframe);
                iframe.progressEventsSent.clear(); // Reset progress tracking for next session
                break;

            case YT.PlayerState.PAUSED:
                iframe.isVideoPlaying = false;
                this.stopTrackingProgress(iframe);
                break;
        }
    },

    startTrackingProgress(player, duration, videoData, iframe) {
        iframe.progressInterval = setInterval(() => {
            const currentTime = player.getCurrentTime();
            const progress = Math.floor((currentTime / duration) * 100);
            const roundedProgress = Math.floor(progress / 10) * 10;

            // Ensure progress events are only sent once per session
            if (roundedProgress >= 10 && !iframe.progressEventsSent.has(roundedProgress)) {
                this.pushToDataLayer(`video_progress_${roundedProgress}%`, videoData.title, duration);
                iframe.progressEventsSent.add(roundedProgress);
            }

        }, 1000); // Check progress every second
    },

    stopTrackingProgress(iframe) {
        clearInterval(iframe.progressInterval); // Clear the interval if it's set
        iframe.progressInterval = null; // Reset the interval reference
    },

    onPlayerError(iframe, error) {
        const errorCode = error.data; // This gives you the error code

        let errorMessage = '';

        switch (errorCode) {
            case 2:
                errorMessage = 'Invalid parameter in the request, such as video ID.';
                break;
            case 5:
                errorMessage = 'Error related to HTML5 player.';
                break;
            case 100:
                errorMessage = 'The video requested was not found, or has been removed.';
                break;
            case 101:
            case 150:
                errorMessage = 'The video owner does not allow it to be played in embedded players.';
                break;
            default:
                errorMessage = 'Unknown error occurred.';
        }

        this.pushToDataLayer('video_error', iframe.getAttribute('name'), null, errorMessage);
    },

    isPageContainsSmallContentSwiperSlider() {
        return document.querySelector('.small-content-slider .swiper') !== null;
    }
}

dataLayerLogic.init();

export default dataLayerLogic;